import { PortugueseWithholdingDto } from '@app/data/dtos/ptrab/withholding/portuguese-withholding.dto';
import { EditWithholdingDto, WithholdingDto } from '@app/data/dtos/ptrab/withholding/withholding.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { PortugueseWithholding, Withholding } from '@app/entities/models/ptrab/withholding/withholding.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapWithholding: MapFromFn<WithholdingDto, Withholding> = (value) =>
  Builder.forModel(Withholding).company(value.company).base(value.base).voluntary(value.voluntary).build();

export const mapPortugueseWithholding: MapFromFn<PortugueseWithholdingDto, PortugueseWithholding> = (value) =>
  Builder.forModel(PortugueseWithholding).list(value.withholding_list).text(value.i18n_text).build();

export const mapWithholdingData: MapFromFn<IDataResponse<WithholdingDto[]>, Withholding[]> = (value) =>
  value.data.map(mapWithholding);

export const mapEditWithholdingDto: MapFromFn<Withholding, EditWithholdingDto> = (value) =>
  Builder.forDto<EditWithholdingDto>()
    .employee_number(value.company.employee_number)
    .voluntary(value.voluntary)
    .company_code(value.company.code)
    .build();

export const mapPortugueseWithholdingData: MapFromFn<IDataResponse<PortugueseWithholdingDto>, PortugueseWithholding> = (
  value
) => mapPortugueseWithholding(value.data);
